<template>
  <div>
    <nav class="navbar is-transparent">
      <Brand />
      <Menu />
      <Right />
    </nav>
  </div>
</template>

<script>
import Brand from './Brand'
import Menu from './menu/Menu'
import Right from './right/Right'

export default {
  name: 'TopBar',
  components: { Brand, Menu, Right }
}
</script>
